import type { ComponentProps } from "react";

import { Breadcrumbs } from "@features/navigations/breadcrumbs";

import type { StrapiMedia } from "@shared/content-types/schemas/media.schema";
import { BackgroundMedia } from "@shared/ui/background-media";
import { ButtonWithIcon } from "@shared/ui/button-with-icon";
import { InfoBadges } from "@shared/ui/info-badges";
import { Heading } from "@shared/ui/typography";

import s from "./cultural-object-hero.module.scss";

export type CulturalObjectHeroProps = ComponentProps<"div"> & {
  title: string;
  backgroundImage?: StrapiMedia | null;
  location?: string;
  time?: string;
  onMapClick?: () => void;
};

export const CulturalObjectHero = (props: CulturalObjectHeroProps) => {
  const { title, backgroundImage, location, time, onMapClick } = props;

  return (
    <div className={s.root}>
      {backgroundImage && (
        <BackgroundMedia
          image={backgroundImage}
          wrapperClassName={s.bgImage}
          type="image"
        />
      )}
      <div className={s.content}>
        <Breadcrumbs className={s.breadcrumbs} />
        <div className={s.infoWrapper}>
          <div className={s.headingWrapper}>
            {(location || time) && (
              <InfoBadges location={location} time={time} className={s.info} />
            )}
            <Heading level={3} tag="h1" className={s.heading}>
              {title}
            </Heading>
          </div>
          <ButtonWithIcon
            className={s.button}
            iconName="map"
            variant="primary-light"
            iconFillColor="azure"
            iconStrokeColor="white"
            onClick={onMapClick}
          >
            Как добраться
          </ButtonWithIcon>
        </div>
      </div>
    </div>
  );
};

CulturalObjectHero.displayName = "CulturalObjectHero";
